import { createMuiTheme } from "@material-ui/core";
import { fade } from "@material-ui/core/styles/colorManipulator";
import notAllowedCursor from "../assets/images/icons/not-allowed.svg";
import { remCalc } from "./helpers";

// TO2DO: see opportunities to move some styles to theme

const theme = createMuiTheme();

const THEME = createMuiTheme({
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
  },
  variables: {
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.16)",
    borderRadius: 6,
    rootColor: "#202124",
    textSecondary: "#4D6172",
    border: "1px solid #DDD",
    dividerBorder: "1px solid #EAEBF0"
  },

  overrides: {
    MuiInput: {
      root: {
        "&:before": {
          borderColor: "#DDD !important"
        }
      },
      underline: {
        "&:after": {
          borderBottomColor: "#1329FE"
        },
        "&:before": {
          borderBottom: "1px solid #DDDDDD"
        }
      }
    },
    MuiSelect: {
      icon: {
        color: "#5F6368"
      },
      select: {
        backgroundColor: "transparent",
        "&:focus": {
          backgroundColor: "transparent"
        }
      }
    },
    MuiFormLabel: {
      root: {
        color: "#808080"
      }
    },
    MuiPopover: {
      root: {
        zIndex: "1303 !important"
      }
    },
    MuiTypography: {
      root: {
        color: "#202124"
      },
      colorTextSecondary: {
        color: "#B6B6B6"
      },
      colorSecondary: {
        color: "#808080"
      },
      h6: {
        fontSize: "0.75rem",
        fontWeight: 600
      },
      body1: {
        ".MuiInputAdornment-root &": {
          fontSize: "0.9375rem",
          color: "#808080"
        }
      },
      bold: {
        fontWeight: 500
      }
    },
    MuiButton: {
      root: {
        "&[disabled]": {
          color: "#B6B6B6"
        }
      },
      outlinedPrimary: {
        border: "1px solid #DDD",
        "&:hover": {
          borderColor: "#DDD",
          backgroundColor: "#F3F4FF"
        }
      },
      textPrimary: {
        "&:hover": {
          backgroundColor: "#F3F4FF"
        }
      },
      outlinedSecondary: {
        color: "#4D6172"
      },
      text: {
        textTransform: "none",
        paddingTop: remCalc(5),
        paddingBottom: remCalc(5)
      },
      contained: {
        "&:hover": {
          boxShadow: "none"
        }
      },
      outlined: {
        "&:hover": {
          backgroundColor: "#EEE"
        }
      }
    },
    MuiIconButton: {
      root: {
        padding: "0.5rem"
      }
    },
    MuiLink: {
      button: {
        "&:not(.no-hover-color):hover svg": {
          color: "#5F6368 !important"
        },
        "&[disabled]": {
          pointerEvents: "none"
        }
      }
    },
    MuiFab: {
      label: {
        textTransform: "none"
      }
    },
    MuiTooltip: {
      tooltip: {
        fontSize: "0.625rem",
        backgroundColor: "#5F6368"
      }
    },
    MuiSwitch: {
      switchBase: {
        color: "#606165"
      },
      thumb: {
        boxShadow:
          "0px 0px 2px rgba(0, 0, 0, 0.12), 0px 2px 2px rgba(0, 0, 0, 0.24)"
      },
      track: {
        backgroundColor: "#DBDCE1",
        opacity: 1
      }
    },
    MuiSvgIcon: {
      root: {
        color: "#5F6368",
        transition:
          "fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, color 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms"
      },
      colorSecondary: {
        color: "#DDDDDD"
      },
      colorDisabled: {
        color: "#C4C4C4"
      },
      colorAction: {
        color: "#808080"
      }
    },
    MuiBadge: {
      colorSecondary: {
        backgroundColor: "#606165",
        zIndex: "auto"
      },
      colorError: {
        zIndex: "auto"
      }
    },
    MuiInputBase: {
      root: {
        fontSize: "0.9375rem",
        color: "#202124",
        "& .Mui-disabled": {
          color: fade("#202124", 0.38)
        }
      },
      input: {
        "&::placeholder": {
          color: "#B6B6B6",
          opacity: 1
        }
      }
    },
    MuiInputLabel: {
      root: {
        fontSize: "0.9375rem",
        color: "#808080",
        "&.Mui-disabled": {
          color: fade("#808080", 0.38)
        }
      }
    },
    MuiOutlinedInput: {
      input: {
        fontSize: "0.875rem"
      },
      notchedOutline: {
        borderColor: "#E0E2E5"
      }
    },
    MuiDialog: {
      paper: {
        borderRadius: 8,
        minWidth: 384
      },
      paperWidthXs: {
        width: 448,
        maxWidth: 600
      }
    },
    MuiDialogActions: {
      root: {
        padding: theme.spacing(1.5, 2, 1.5, 3),

        "& button": {
          padding: theme.spacing(1.25, 2),
          lineHeight: "1rem",
          // border: "1px solid #DDD",

          "&:first-of-type": {
            backgroundColor: "#ECEEFF",
            "&:hover": {
              backgroundColor: "#F3F4FF"
            },

            "&.Mui-disabled": {
              color: "rgba(0, 0, 0, 0.26)",
              backgroundColor: "rgba(0, 0, 0, 0.08) !important"
            }
          },

          "&:last-of-type": {
            "&:hover": {
              backgroundColor: "#F3F4FF"
            }
          }
        }
      }
    },
    MuiExpansionPanel: {
      root: {
        boxShadow: "none",

        "&:before": {
          content: "none"
        }
      }
    },
    MuiExpansionPanelSummary: {
      root: {
        padding: 0
      },
      content: {
        margin: "0 !important"
      }
    },
    MuiExpansionPanelDetails: {
      root: {
        padding: 0
      }
    },
    MuiLinearProgress: {
      root: {
        height: 8,
        borderRadius: 8,
        display: "flex",
        alignItems: "center"
      },
      bar: {
        borderRadius: 8,
        height: 8
      },
      colorPrimary: {
        backgroundColor: "#ECEEFF"
      },
      dashedColorPrimary: {
        height: 6,
        borderRadius: 8,
        backgroundColor: "#EEEEEE",
        backgroundImage: "none",
        animation: "none"
      },
      bar2Buffer: {
        backgroundColor: "#F50057"
      }
    },
    MuiSnackbar: {
      root: {
        marginBottom: theme.spacing(1.5)
      }
    },
    MuiSnackbarContent: {
      message: {
        fontSize: remCalc(16),
        "& svg": {
          color: "#fff"
        }
      }
    },
    MuiBackdrop: {
      root: {
        backgroundColor: "rgba(0,0,0,0.4)"
      }
    },
    MuiPickersCalendarHeader: {
      transitionContainer: {
        "& p": {
          fontWeight: 500,
          fontSize: "0.875rem",
          letterSpacing: "0.1px",
          opacity: "60%"
        }
      },
      dayLabel: {
        color: "#808080"
      },
      daysHeader: {
        "& span:nth-last-child(-n+2)": {
          color: "#B6B6B6"
        }
      }
    },
    MuiPickersDay: {
      day: {
        color: "#202124"
      },
      dayDisabled: {
        color: "#808080"
      },
      daySelected: {
        color: "#fff !important"
      }
    },
    MuiPickersStaticWrapper: {
      staticWrapperRoot: {
        alignItems: "center",
        "& .MuiPickersBasePicker-container": {
          width: "100%",
          alignItems: "center",
          "& .MuiPickersBasePicker-pickerView": {
            width: "100%",
            maxWidth: 384,
            "& .MuiPickersCalendarHeader-daysHeader": {
              width: "100%",
              justifyContent: "space-between"
            }
          },
          "& .MuiPickersCalendar-week": {
            width: "100%",
            justifyContent: "space-between"
          }
        }
      }
    },
    MuiTableCell: {
      root: {
        borderBottom: "1px solid #EEEEEE"
      },
      body: {
        color: "#202124",
        fontSize: "0.9375rem"
      }
    },
    MuiTablePagination: {
      caption: {
        color: "#202124"
      },
      actions: {
        marginLeft: theme.spacing(2)
      }
    }
  },
  snackbar: {
    textColor: "#fff"
  },

  palette: {
    primary: {
      main: "#1329FE"
    },
    darkGrey: {
      main: "#4D6172"
    },
    darkNavy: {
      main: "#181947",
      light: "rgba(25,27,63,0.78)"
    },
    secondary: {
      main: "#808080"
    },
    error: {
      main: "#D93024",
      secondary: "rgba(217, 48, 36, 0.08)",
      thirdary: "#F6CECB"
    },
    text: {
      primary: "#202124"
    },
    success: {
      main: "#07A35A",
      secondary: "#E8F2EC",
      thirdary: "#C5E7D1"
    },
    background: {
      default: "#F7F7F7"
    }
  },
  cursors: {
    notAllowed: `url(${notAllowedCursor}), not-allowed`
  }
});

export default THEME;
